import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'
import {AppName, getAppName} from 'util/AppName'

export const TaskZuUserConfigDict = {
	enabled: {
		label: 'Taskzuweisungen',
		type: 'boolean',
		visibleSelector: selPropGen(PropID.taskZuVis, propDefaultTrue),
		...(getAppName() !== AppName.timelineTask ? {
			defaultValue: false,
			defaultOverrideSelector: selPropGen(PropID.taskZuDefault, propDefaultFalse),
		} : {
			defaultValue: true,
			defaultOverrideSelector: selPropGen(PropID.taskZuDefault, propDefaultTrue),
		}),
	},
} as const